import { black, gray } from './Colors';

export const cardCentering = {
  alignItems: 'center',
  display: 'flex',
  height: '100vh'
};

export const cardSize = {
  '@media screen and (max-width:480px)': {
    width: 343
  },
  boxShadow: 0,
  marginLeft: '16px',
  marginRight: '16px',
  width: 480
};

export const cardContentPadding = {
  '&:last-child': {
    '@media screen and (max-width:480px)': {
      paddingBottom: '32px'
    },
    paddingBottom: '40px'
  },
  '@media screen and (max-width:480px)': {
    padding: '32px 16px'
  },
  padding: '40px'
};

export const mypageWrapper = {
  '@media screen and (max-width:960px)': {
    flexDirection: 'column'
  },
  display: 'flex'
};

export const mypageHeader = {
  '@media screen and (max-width:960px)': {
    height: '48px',
    padding: '0px 16px',
    top: '48px'
  },
  alignItems: 'center',
  background: '#FFFFFF',
  borderBottom: '1px solid #DBDBE0',
  boxSizing: 'border-box',
  display: 'flex',
  height: '80px',
  justifyContent: 'space-between',
  padding: '24px',
  position: 'sticky',
  top: 0,
  width: '100%',
  zIndex: 10
};

export const mypageHeaderTitle = {
  '@media screen and (max-width:960px)': {
    fontSize: '18px'
  },
  color: black,
  fontSize: '24px',
  fontWeight: 700
};

export const titleFontSize = {
  fontSize: '22px'
};

export const textFontSize = {
  '@media screen and (max-width:480px)': {
    fontSize: '12px'
  },
  fontSize: '16px'
};

export const buttonFont = {
  fontSize: '15px'
};

export const titleMb = {
  '@media screen and (max-width:480px)': {
    marginLeft: 0
  },
  fontSize: '22px',
  marginBottom: '24px'
};

export const textMb = {
  marginBottom: '16px'
};

export const formWideMb = {
  marginBottom: '24px'
};

export const formNarrowMb = {
  marginBottom: '8px'
};

export const formExtraNarrowMb = {
  marginBottom: '0px'
};

export const w100 = {
  width: '100%'
};

export const sideBar = {
  '@media screen and (max-width:960px)': {
    display: 'block'
  },
  display: 'flex'
};

export const breadcrumb = {
  '.MuiBreadcrumbs-separator': {
    margin: '0 8px 2px 8px'
  },
  display: 'flex',
  fontSize: '12px',
  margin: '12px 0 0 24px'
};

export const breadcrumbsText = {
  color: gray,
  fontSize: '12px'
};

export const sizeBelowTenMb = (size: number): boolean =>
  size / 1024 / 1024 > 10;

export const sizeBelowTwentyMb = (size: number): boolean =>
  size > 20 * 1024 * 1024;

export const formLabelWrapper = {
  fontSize: '12px',
  marginBottom: '4px'
};
